import { Box, Stack, Typography, useTheme } from "@mui/material";
import { ChatButton, ChatTextField } from "Common/Components";
import { INFO_TYPE } from "Common/Constants";
import { useMatchDownMd } from "Common/Hooks";
import { SendChatOutlined } from "Icons/Icons";
import { CUSTOM_RADII } from "Theme/Shape";
import { ChangeEvent, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "src/Store";

interface AskContainerProps {
  sendRequestMessage: (requestMessage: string) => void;
  openSnackBar?: (message: string, isSuccess: boolean, isWarning?: boolean) => void;
  infoType?: INFO_TYPE;
}
export const AskContainer = (props: AskContainerProps) => {
  const { sendRequestMessage, openSnackBar, infoType } = props;
  const [message, setMessage] = useState("");
  const [helperText, setHelperText] = useState<string | undefined>(undefined);
  const matchDownMd = useMatchDownMd();
  const handleInputChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value);
    if (e.target.value.length >= 2000) {
      setMessage(e.target.value);
      setHelperText("Character limit should be less than 2000.");
    } else {
      setHelperText("");
    }
  };

  const conversationLoading = useSelector((state: RootState) => state.conversation.conversationLoading);

  const sendMessage = () => {
    if (conversationLoading && openSnackBar) {
      openSnackBar("Please wait while the current message loads.", false, true);
    }
    if (message && !conversationLoading) {
      sendRequestMessage(message);
      setMessage("");
    }
  };
  const theme = useTheme();
  return (
    <Box sx={{ display: "flex", width: "auto", flex: 0 }}>
      <Stack sx={{ width: "100%", px: matchDownMd ? 1 : 7, mb: 2 }}>
        <Stack
          sx={{
            mx: "auto",
            width: "100%",
            maxWidth: 800,
            justifyContent: "flex-end",
            position: "relative",
            background: theme.palette.grey[100],
            borderRadius: CUSTOM_RADII.pill,
            px: 1.5,
            py: 1,
            display: "flex",
            alignItems: "center",
          }}
          direction={"row"}
          spacing={0.5}
        >
          <ChatTextField
            value={message}
            onChange={handleInputChange}
            onEnterPress={() => {
              if (!helperText) {
                sendMessage();
              }
            }}
            placeHolderText={
              infoType === INFO_TYPE.SERVICE_HISTORY
                ? "Please provide the equipment serial number to inquire about service information."
                : undefined
            }
            helperText={helperText}
          />
          <ChatButton
            hasBackground
            backgroundColor={theme.palette.grey[300]}
            Icon={SendChatOutlined}
            onClick={sendMessage}
            disabled={!message.trim() || conversationLoading || !!helperText}
          />
        </Stack>
        <Typography
          variant="caption"
          sx={{
            bottom: 0,
            width: "100%",
            textAlign: "center",
            paddingBottom: "3px",
            pt: 1,
            color: theme.palette.grey[500],
          }}
        >
          Ask AMI may generate error responses. Always verify information and check references for more accurate information!
        </Typography>
      </Stack>
    </Box>
  );
};
